import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from '../../../../redux/connect';
import {
  getPermissionsHasGrowled,
  hasPermissionsViolation,
} from '../../../../redux/selectors';
import T from 'i18n-react';
import { Button, ModalConfirmation } from '@adsk/bim360-matrix-react-components';

export class PureNoPermissionsModal extends Component {
  onConfirm() {
    // we're clearing the browser url from any query params and then reloading
    window.history.replaceState({}, '', `${window.location.href.split('?')[0]}`);
    window.location.reload();
  }
  render() {
    const { hasViolation, hasGrowled, container } = this.props;
    if (!hasViolation || hasGrowled) { return null; }

    return (
      <ModalConfirmation
        container={container}
        onConfirm={this.onConfirm}
        title={T.translate('permissionsErrors.modalHeader')}
        message={T.translate('permissionsErrors.modalMessage')}
        confirmationButtonLabel={T.translate('permissionsErrors.modalConfirmation')}
        confirmationButtonStyleType={Button.StyleType.PRIMARY}
        noCancelButton
        disableModalExit
      />
    );
  }
}

PureNoPermissionsModal.displayName = 'NoPermissionsModal';

PureNoPermissionsModal.propTypes = {
  container: PropTypes.object.isRequired,
  hasViolation: PropTypes.bool.isRequired,
  hasGrowled: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  hasViolation: hasPermissionsViolation(state),
  hasGrowled: getPermissionsHasGrowled(state),
});

export default connect(mapStateToProps)(PureNoPermissionsModal);
